
import { Component, Mixins, Emit, Prop } from "vue-property-decorator";
import { ReceptionDateTranslator } from "../../../domain/workflow";
import { DateDuration } from "../../../domain/system";
import { DepartmentGroup } from "../../../domain/department";
import { BrowserUtility, BrowserKinds } from "../../../utilities";
import { MessageBroadcaster } from "../../system/utilities";
import { WriteMethodTypes, WriteMethodTypeValue } from "../../../domain/format";

@Component({
  filters: {
    dateStr(value: Date) {
      const dateTranslator = new ReceptionDateTranslator();
      return dateTranslator.toDateDispString(value);
    },
    timeStr(value: Date) {
      const dateTranslator = new ReceptionDateTranslator();
      return dateTranslator.toTimeDispString(value);
    },
    dateTimeStr(value: Date) {
      const dateTranslator = new ReceptionDateTranslator();
      return dateTranslator.toDateTimeDispString(value);
    },
    emptyStr(value: string) {
      return value ? value : "";
    },
    dateFixStr(value: Date) {
      const dateTranslator = new ReceptionDateTranslator();
      const dateStr = dateTranslator.toDateDispString(value);
      return dateStr ? dateStr : "--";
    }
  }
})
export default class WorkflowCommonMixin extends Mixins() {
  @Prop()
  isSearchable: boolean;

  @Emit()
  changeManagerHistorySearchEnable(isEnable: boolean): void {}

  toDateFixStr(value: Date) {
    const dateTranslator = new ReceptionDateTranslator();
    const dateStr = dateTranslator.toDateDispString(value);
    return dateStr ? dateStr : "--";
  }

  toDateTimeFixStr(value: Date) {
    const dateTranslator = new ReceptionDateTranslator();
    const dateStr = dateTranslator.toDateTimeDispString(value);
    return dateStr ? dateStr : "--";
  }

  resetDateRange(duration: number, isMonth: boolean): DateDuration {
    if (!duration) { return new DateDuration(null, null); }

    const todayDuration = DateDuration.today();
    if (isMonth) {
      return DateDuration.fromMonths(todayDuration.from, duration);
    } else {
      return DateDuration.fromDays(todayDuration.from, duration);
    }
  }

  showValidationMessage(title: string, message: string) {
    this.$warn(title, message);
  }

  showRequestErrorMessage(title: string, defaultMessage: string, exception: any) {
    console.log(exception);
    let message = defaultMessage;
    if (exception.response) {
      if (exception.response.status === 500) {
        message = exception.response.data.exceptionMessage; // TODO 共通クラスができたらそのプロパティを参照するように
      }
    }
    this.$error(title, message, exception);
  }

  createPostMessage(key: string, value: any = null): string {
    const message = {
      key,
      value,
    };
    return JSON.stringify(message);    
  }

  notifyMessage(key: string): void {
    try {
      const message = this.createPostMessage(key);
      if (window.opener) {
        window.opener.postMessage(message, "*");
      } else if (this.$configuration.behavior.localhost.window.opener.isEnable) {
        MessageBroadcaster.sendTo("Workflow", message);
        MessageBroadcaster.sendTo("WorkflowReception", message);
      }
    } catch (e) {
      console.log(e);
    }
  }

  isIE(): boolean {
    return BrowserUtility.getBrowserKind() === BrowserKinds.InternetExplorer;
  }

  get formatListSelectorTargetWriteMethodTypes(): WriteMethodTypeValue[] {
      return WriteMethodTypes.WorkflowDefaultTargets;
  }

  get storedDepartmentGroup(): DepartmentGroup {
    return this.$store.getters.departmentGroup;
  }

  get isDepartmentGroupEnable(): boolean {
    return this.$configuration.behavior.departmentGroup.feature.isEnable;
  }
}
